import { motion } from "framer-motion";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

interface Competitor {
  name: string;
  url: string;
  seoScore: number;
  geoScore: number;
  trend: "up" | "down" | "stable";
}

const competitors: Competitor[] = [
  {
    name: "Site-ul tău",
    url: "magazin.ro",
    seoScore: 72,
    geoScore: 45,
    trend: "up",
  },
  {
    name: "Competitor A",
    url: "competitor-a.ro",
    seoScore: 68,
    geoScore: 52,
    trend: "stable",
  },
  {
    name: "Competitor B",
    url: "competitor-b.ro",
    seoScore: 81,
    geoScore: 38,
    trend: "down",
  },
  {
    name: "Competitor C",
    url: "competitor-c.ro",
    seoScore: 55,
    geoScore: 61,
    trend: "up",
  },
];

function TrendIcon({ trend }: { trend: Competitor["trend"] }) {
  if (trend === "up") {
    return <TrendingUp className="w-4 h-4 text-primary" />;
  }
  if (trend === "down") {
    return <TrendingDown className="w-4 h-4 text-destructive" />;
  }
  return <Minus className="w-4 h-4 text-muted-foreground" />;
}

function ScoreBadge({ score, highlight }: { score: number; highlight?: boolean }) {
  const getColor = () => {
    if (score >= 70) return "bg-primary/10 text-primary";
    if (score >= 40) return "bg-yellow-500/10 text-yellow-600";
    return "bg-destructive/10 text-destructive";
  };

  return (
    <span
      className={`inline-flex items-center justify-center w-12 h-7 rounded-full text-sm font-semibold ${getColor()} ${
        highlight ? "ring-2 ring-primary ring-offset-2" : ""
      }`}
    >
      {score}
    </span>
  );
}

export function CompetitorTable() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 }}
      className="card-elevated overflow-hidden"
    >
      <div className="p-6 border-b border-border">
        <h3 className="text-lg font-semibold text-foreground">
          Competitor Watch
        </h3>
        <p className="text-sm text-muted-foreground mt-1">
          Compară scorul tău cu competitorii din piață
        </p>
      </div>
      
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Site</TableHead>
            <TableHead className="text-center">Scor SEO</TableHead>
            <TableHead className="text-center">Scor GEO</TableHead>
            <TableHead className="text-center">Trend</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {competitors.map((competitor, index) => (
            <TableRow
              key={competitor.url}
              className={index === 0 ? "bg-primary/5" : ""}
            >
              <TableCell>
                <div>
                  <p className="font-medium text-foreground">
                    {competitor.name}
                    {index === 0 && (
                      <span className="ml-2 text-xs text-primary">(Tu)</span>
                    )}
                  </p>
                  <p className="text-sm text-muted-foreground">
                    {competitor.url}
                  </p>
                </div>
              </TableCell>
              <TableCell className="text-center">
                <ScoreBadge score={competitor.seoScore} highlight={index === 0} />
              </TableCell>
              <TableCell className="text-center">
                <ScoreBadge score={competitor.geoScore} highlight={index === 0} />
              </TableCell>
              <TableCell className="text-center">
                <div className="flex justify-center">
                  <TrendIcon trend={competitor.trend} />
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </motion.div>
  );
}
